import React from 'react';

import classnames from 'classnames';
import styles from './chips.module.scss';

type Props = {
  children: React.ReactNode;
  color: 'secondary' | 'success' | 'warning' | 'future' | 'primary';
};

export const Chips: React.FC<Props> = ({ children, color }: Props) => (
  <span
    className={classnames(styles.container, {
      [styles.information]: color === 'secondary',
      [styles.success]: color === 'success',
      [styles.warning]: color === 'warning',
      [styles.future]: color === 'future',
      [styles.primary]: color === 'primary',
    })}
  >
    {children}
  </span>
);
